<main class="auctions-list-page container">
  <h1 class="auctions-list-page__header">
    {{ 'home.auctions' | translate }}
  </h1>

  <div class="auctions-list-page__content">
    @if (filtersSheetOpen()) {
      <button
        type="button"
        class="auctions-list-page__backdrop"
        (click)="closeFiltersSheet()"
        [attr.aria-label]="'global.close' | translate"></button>
    }

    <aside
      class="auctions-list-page__filters"
      [class.auctions-list-page__filters--sheet]="filtersSheetOpen()">
      <div class="auctions-list-page__sheet-head">
        <h2 class="auctions-list-page__sheet-title">
          {{ 'solutions.filters.toggle' | translate }}
        </h2>
        <button
          type="button"
          class="auctions-list-page__sheet-close"
          (click)="closeFiltersSheet()"
          [attr.aria-label]="'global.close' | translate">
          <i class="iconsax" icon-name="x"></i>
        </button>
      </div>
      <div class="auctions-list-page__sheet-body">
        <pwj-filters-panel titleKey="solutions.filters.toggle" icon="filter-search">
          <pwj-products-filters></pwj-products-filters>
        </pwj-filters-panel>
      </div>
    </aside>

    <div class="auctions-list-page__main">
      @if (!isLoading) {
        <pwj-sorts-bar
          class="auctions-list-page__sort-bar"
          variant="segmented"
          [sorts]="filters"
          translateKey="enums.auctionStatus."
          [haveInitializeTab]="false"
          [resultsCount]="allAuctionsCount"
          [showFiltersButton]="showFiltersTriggerOnSortBar()"
          (filtersClick)="onFiltersFromSortBar()"></pwj-sorts-bar>
      } @else {
        <div class="auctions-list-page__sort-bar-skeleton" aria-hidden="true">
          <div class="auctions-list-page__sort-bar-skeleton-inner">
            <ngx-skeleton-loader
              count="1"
              class="auctions-list-page__sort-bar-skeleton-tabs"
              [theme]="{
                width: '100%',
                height: '2.375rem',
                'border-radius': '0.5rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <div class="auctions-list-page__sort-bar-skeleton-meta">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '4.5rem',
                  height: '0.875rem',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
              @if (showFiltersTriggerOnSortBar()) {
                <ngx-skeleton-loader
                  count="1"
                  [theme]="{
                    width: '2.125rem',
                    height: '2.125rem',
                    'border-radius': '0.5rem',
                    margin: '0',
                  }"></ngx-skeleton-loader>
              }
            </div>
          </div>
        </div>
      }

      <div class="auctions-list-page__cards">
        @if (!isLoading) {
          @if (auctionsData.length > 0) {
            <ul class="cards-list">
              @for (auction of auctionsData; track auction._id) {
                <li class="cards-list__item">
                  <pwj-auction-card [data]="auction"></pwj-auction-card>
                </li>
              }
            </ul>
          } @else {
            <pwj-no-content message="auctions.noAuctions"></pwj-no-content>
          }
        } @else if (isLoading) {
          <ul class="cards-list">
            <pwj-auction-card-skeleton [count]="6" [wrapInListItem]="true" />
          </ul>
        }
      </div>

      @if (allAuctionsCount && allAuctionsCount > 6) {
        <pwj-pagination
          [dataCount]="allAuctionsCount"
          [perPage]="6"></pwj-pagination>
      }
    </div>
  </div>
</main>
